import { render, staticRenderFns } from "./suporte-motivo-transferencia-reserva.vue?vue&type=template&id=61290bb6&scoped=true"
import script from "./suporte-motivo-transferencia-reserva.vue?vue&type=script&lang=ts"
export * from "./suporte-motivo-transferencia-reserva.vue?vue&type=script&lang=ts"
import style0 from "./suporte-motivo-transferencia-reserva.vue?vue&type=style&index=0&id=61290bb6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61290bb6",
  null
  
)

export default component.exports